import React from 'react';
import styled from 'styled-components';
import IosWifiConnection from './WifiSection/IosWifiConnection';
import AndroidWifiConnection from './WifiSection/AndroidWifiConnection';

type Props = {
  isAndroid?: boolean;
  place?: 'airport' | 'port';
  isDetailStep?: boolean;
};

function Step1({
  isAndroid = false,
  place = 'airport',
  isDetailStep = false,
}: Props) {
  const WifiConnectionComponent = isAndroid
    ? AndroidWifiConnection
    : IosWifiConnection;

  const titleText = isDetailStep ? (
    <>
      출국 인증을 위해
      <br />
      {place === 'airport' ? '공항' : '항구'} 와이파이를 연결해주세요
    </>
  ) : (
    `${place === 'airport' ? '공항' : '항구'} 와이파이 연결`
  );

  return (
    <Container isDetailStep={isDetailStep}>
      <StepLabel className='notranslate'>Step 1</StepLabel>
      <Title isDetailStep={isDetailStep}>{titleText}</Title>
      <Description>
        KTP 출국 확인은 {place === 'airport' ? '공항' : '항구'} 와이파이 연결을
        통해 {isDetailStep && <br />}출국장 방문 사실이 인증됩니다.
        {isDetailStep || (
          <>
            <br />
            '설정' 에서 {place === 'airport' ? '공항' : '항구'} 와이파이 연결 후
            인증을 진행해주세요.
          </>
        )}
      </Description>
      <WifiConnectionComponent place={place} />
    </Container>
  );
}

const Container = styled.div<{ isDetailStep?: boolean }>`
  ${({ isDetailStep = false }) =>
    isDetailStep &&
    `
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      text-align: center;
    `}
`;

const StepLabel = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 100px;
  background-color: #246cf6;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  flex-basis: auto;
  margin-bottom: 12px;
`;

const Title = styled.h2<{ isDetailStep?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ isDetailStep = false }) =>
    isDetailStep ? 'center' : 'flex-start'};
  font-size: 18px;
  font-weight: 700;
  color: #3a3b3e;
  width: 100%;
  margin-bottom: 8px;
  line-height: 27px;

  & > img {
    width: 36px;
    height: 36px;
  }
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #80848a;
  margin-bottom: 16px;
  width: 100%;
`;

export default Step1;
